export default function register(type: string, fn?: any): void {
  if ((window as any).attachEvent) {
    (window as any)['e' + type + fn] = fn;
    (window as any)[type + fn] = function () {
      (window as any)['e' + type + fn](window.event);
    };
    (window as any).attachEvent('on' + type, (window as any)[type + fn]);
  } else {
    window.addEventListener(type, fn, false);
  }
}



// WEBPACK FOOTER //
// ./src/events.ts